import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges} from '@angular/core';
import {CompareWith, Constants} from '../../constants';
import {RulesService} from '../../rules.service';
import {ICondition} from '../../model/condition.interface';
import {Router} from '@angular/router';
import {SetConditionOption} from '../../model/Set-condition.option.service';


@Component({
  selector: 'app-set-condition',
  templateUrl: './set-condition.component.html',
  styleUrls: ['./set-condition.component.scss']
})
export class SetConditionComponent implements OnInit, OnDestroy, OnChanges {
  title: string = Constants.THING_SEARCHBOX_TITLE;
  attributeTitle: string = Constants.ATTR_SEARCHBOX_TITLE;
  referenceAttributeTitle: string = Constants.ATTR_SEARCHBOX_TITLE;
  attributePreLabel: string;
  referenceAttributePreLabel: string;
  staticValue: number = CompareWith.STATIC_VALUE;
  sameThing: number = CompareWith.SAME_THING;
  anotherThing: number = CompareWith.DIFF_THING;
  propertyName: string = Constants.NAME;
  labelName: string = Constants.DATA_TYPE;
  top: string = Constants.TOP;
  operators = Constants.OPERATORS;
  errorMessage: string;
  thingList;
  compareWith: any = null;
  referenceThing = null;
  rhsValue = null;
  attribute = null;
  url: string = Constants.URL;
  operator: string = Constants.EQUALS;
  hasError = {
    referenceThing: false,
    staticValue: false,
    referenceAttribute: false,
    attribute: false
  };
  private subscription;
  @Input() selectedItem;
  @Input() index;
  @Input() openTo;
  @Input() condition;
  @Output() cancelEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saveCondition: EventEmitter<any>  = new EventEmitter<any>();
  constructor(private ruleService: RulesService,
              private renderer: Renderer2, private router: Router, private options: SetConditionOption) { }

  ngOnInit() {
    this.getThingList();
    if (this.options && this.options.condition) {
      this.populateValueForEditing(this.options.condition);
    }
    if (this.options && this.options.selectedItem) {
      this.selectedItem = this.options.selectedItem;
    }
    if (this.options && !isNaN(this.options.index)) {
      this.index = this.options.index;
    }
  }

   ngOnChanges(changes: SimpleChanges) {
    if (changes['condition'] || changes['selectedItem']) {
      const condition = changes['condition'] ? changes['condition'].currentValue : this.condition;
      this.populateValueForEditing(condition);
    }
  }
  get isTop() {
    return this.openTo === Constants.TOP ;
  }
  get attributes() {
    return this.selectedItem.schema.attributes;
  }
  get compareAttributes() {
    return this.selectedItem.schema.attributes
      .filter((attribute) => attribute.datatype === this.attribute.datatype && attribute.name !== this.attribute.name);
  }
  get selectListItems() {
    if (this.isFirstConditionEdit()) {
      return this.thingList;
    }
    return this.ruleService.getParentThing() && this.ruleService.hasMoreThanOneCondition() ?
      [this.ruleService.getParentThing()] : this.thingList;
  }
  get primaryThings() {
    return this.ruleService.hasMoreThanOneCondition() ? this.thingList.filter(thing => thing.token === this.selectedItem.token)
     : this.dependentThings;
  }
  get dependentThings() {
    return this.thingList.filter(thing => thing.token !== this.selectedItem.token);
  }

  get dependentAttributes() {
    return this.referenceThing ?
      this.referenceThing.schema.attributes
      .filter((item) => item.datatype === this.attribute.datatype) : [];
  }
  isBoolean(attribute) {
    return attribute ? attribute.datatype.toUpperCase() === Constants.BOOLEAN : false;
  }
  isNumber(attribute) {
    return attribute ? attribute.datatype.toUpperCase() === Constants.NUMBER : false;
  }
  selectOperator(operator) {
     this.operator = operator;
  }
  onReferenceThingSelection(thing) {
    this.referenceThing = thing;
    this.referenceAttributeTitle = Constants.ATTR_SEARCHBOX_TITLE;
  }
  onThingSelection(thing) {
    this.selectedItem = thing;
    this.attribute = null;
    this.attributeTitle = Constants.ATTR_SEARCHBOX_TITLE;
  }
  onAttributeSelection(attribute) {
    this.attribute = attribute;
    this.attributeTitle = attribute.name;
    this.hasError.attribute = false;
    this.attributePreLabel = Constants.ATTR_PRE_LABEL;
    this.reset();
  }
  onSelectRHSAttribute(attribute) {
    this.rhsValue = attribute.name;
    this.referenceAttributeTitle = attribute.name;
    this.hasError.referenceAttribute = false;
    this.referenceAttributePreLabel = Constants.ATTR_PRE_LABEL;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  cancel() {
    if (this.options && this.options.onCancel) {
      this.options.onCancel();
      return;
    }
    this.cancelEdit.emit(true);
  }
  selectCompareItem(compareWith) {
    this.resetValidationErrors();
    this.referenceAttributeTitle = Constants.ATTR_SEARCHBOX_TITLE;
    switch (compareWith) {
      case CompareWith.STATIC_VALUE :
        this.referenceThing = null;
        this.rhsValue = null;
        break;
      case CompareWith.SAME_THING:
        this.referenceThing = this.selectedItem;
        this.rhsValue = null;
        break;
      case CompareWith.DIFF_THING:
        this.referenceThing = null;
        this.rhsValue = null;
        break;
    }
  }
  populateValueForEditing (condition: ICondition): void {
    if (!condition) {
      return;
    }
    if (condition.attributeParent === null) {
      return;
    }
    this.attributePreLabel = this.ruleService.getPreLabel(condition.attributeName);
    this.referenceAttributePreLabel = condition.constraint.referenceId ?
      this.ruleService.getPreLabel(condition.constraint.value) : Constants.ATTR_PRE_LABEL;
    this.rhsValue = condition.constraint.referenceId ?
             this.attributeName(condition.constraint.value) :  condition.constraint.value;
    this.attribute = this.ruleService.getItem(condition.attributeName, condition.attributeParent);
    this.attributeTitle = this.attribute ? this.attribute.name : Constants.ATTR_SEARCHBOX_TITLE;
    this.referenceThing = this.ruleService.getThing(condition.constraint.referenceId);
    this.operator = condition.operator ? condition.operator : Constants.EQUALS;
    if (condition.constraint.referenceId) {
      this.compareWith = condition.constraint.referenceId === condition.attributeParent ?
        CompareWith.SAME_THING : CompareWith.DIFF_THING;
    }else {
      this.compareWith = CompareWith.STATIC_VALUE;
    }
    this.referenceAttributeTitle = this.compareWith === CompareWith.STATIC_VALUE ?
      Constants.ATTR_SEARCHBOX_TITLE : this.attributeName(condition.constraint.value);
    this.title = this.referenceThing ? this.referenceThing.name : Constants.THING_SEARCHBOX_TITLE;
  }
  save(compareWith) {
    if (!this.validate(compareWith)) {
      return;
    };
    const condition: ICondition = {
      attributeName: `${this.attributePreLabel}.${this.attribute.name}`,
      operator: this.operator,
      attributeParent: this.selectedItem.token,
      constraint: {
        value: this.referenceThing ? `${this.referenceAttributePreLabel}.${this.rhsValue}` : this.rhsValue,
        referenceId: this.referenceThing ? this.referenceThing.token : null
      }
    };
    if (this.isFirstConditionEdit()) {
      this.ruleService.reSetParentThing();
    }
    this.ruleService.addThingToList(this.selectedItem);
    if (this.referenceThing) {
      this.ruleService.addThingToList(this.referenceThing);
    }

    if (this.options && this.options.onSave) {
      this.options.onSave(condition);
      return;
    }

    this.saveCondition.emit(condition);
  }
  private reset() {
    this.operator = Constants.EQUALS;
    this.rhsValue = null;
    if (!this.compareWith) {
      this.compareWith = CompareWith.STATIC_VALUE;
    }
  }
  private getThingList() {
    this.subscription = this.ruleService.getThingListSubject()
      .subscribe((data) => this.thingList = data);
  }
  private resetValidationErrors() {
    this.hasError.referenceAttribute = false;
    this.hasError.staticValue = false;
    this.hasError.referenceThing = false;
  }
  private attributeName(name): string {
     return name.split(Constants.DOT)[1];
  }
  private validate(compareWith): boolean {
    if (!this.attribute) {
      this.hasError.attribute = true;
      return false;
    }
    switch (compareWith) {
      case CompareWith.STATIC_VALUE:
          if (this.rhsValue === null || this.rhsValue === Constants.EMPTY || this.rhsValue === undefined) {
            this.hasError.staticValue = true;
            this.errorMessage = Constants.MESSAGES.ERROR.REQUIRED;
            this.renderer.selectRootElement('#static').focus();
            return false;
          }
          break;
      case CompareWith.SAME_THING:
        if (!this.rhsValue || this.rhsValue === Constants.EMPTY) {
          this.hasError.referenceAttribute = true;
          return false;
        }
        break;
      case  CompareWith.DIFF_THING:
        if (this.referenceThing === null) {
          this.hasError.referenceThing = true;
          return false;
        }
        if (!this.rhsValue || this.rhsValue === Constants.EMPTY ) {
          this.hasError.referenceAttribute = true;
          return false;
        }
        break;
     }
     return true;
  }

  private isFirstConditionEdit() {
    return this.ruleService.hasExactOneCondition() && this.index === 0 && !!this.ruleService.getParentThing();
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/set-condition/set-condition.component.ts